import { useSelector } from 'react-redux';

import { useLocalization } from 'redux/localization/utils/hooks';

const Loading = () => {
  const cartReducer = useSelector((state) => state.cart);
  const { t } = useLocalization();
  const { skuBeingAdded, data } = cartReducer;

  let cartItemSkus = [];

  if (data?.items) {
    cartItemSkus = data.items.map((item) => item.sku);
  }

  if (skuBeingAdded && !cartItemSkus.includes(skuBeingAdded)) {
    return (
      <div className="c7-loading--block">
        <div className="c7-spinner" role="status" aria-live="polite">
          <span className="c7-sr-only">
            {t('general.accessibility.loading')}
          </span>
        </div>
      </div>
    );
  }
  return (
    <div className="c7-loading--block c7--hidden">
      <div className="c7-spinner" role="status" aria-live="polite" />
    </div>
  );
};

export default Loading;
